import Scene = Phaser.Scene;
import TextUtils from "@/utils/text-utils";
import Text = Phaser.GameObjects.Text;
import {Keys} from "@/constants/key";
import {Fonts} from "@/constants/font";
import SpriteUtils from "@/utils/sprite-utils";
import CU from "@/utils/c-u";

export class CampaignTimerPanel extends Phaser.GameObjects.Container {

    private clickCallback: (() => unknown) | undefined;

    private timeText: Text | undefined;

    constructor(scene: Scene, x: number, y: number, ribbonTheme: RibbonTheme, offerName: string, withTimer: boolean, clickCallback: () => unknown) {
        super(scene);
        this.clickCallback = clickCallback;
        this.setDepth(90);

        this.scene = scene;
        this.x = x * CU.S;
        this.y = y * CU.S;

        let campaignButtonRibbon = SpriteUtils.addSprite(this.scene!, 0, 0, CampaignTimerPanel.getRibbonKey(ribbonTheme));
        let campaignButtonName = TextUtils.addTextAdvanced(this.scene!, offerName.toUpperCase(),
            15 + (withTimer ? 0 : -4), campaignButtonRibbon.y - 9 + (withTimer ? 0 : 2),
            CampaignTimerPanel.getMainColor(ribbonTheme), 12, 'normal', 400, 'center', 2, Fonts.MYRIADPRO_BOLD);
        campaignButtonName.setShadow(0, 0, '#ffffff');
        campaignButtonName.setStroke('#000000', 2);

        this.add([campaignButtonRibbon, campaignButtonName]);

        if (withTimer) {
            this.timeText = TextUtils.addTextAdvanced(this.scene!, offerName,
                15, campaignButtonRibbon.y + 4,
                CampaignTimerPanel.getTimerColor(ribbonTheme), 9, 'normal', 400, 'center', 2, Fonts.MYRIADPRO_BOLD);
            this.timeText.setShadow(0, 0, '#ffffff');
            this.timeText.setStroke('#000000', 2);

            this.add(this.timeText);
        }

        campaignButtonRibbon.setInteractive().on('pointerup', clickCallback);
    }

    public setTime(remainTime: string) {
        this.timeText!.setText(remainTime.toUpperCase());
    }

    public setOrigin(x: number, y: number): void {
        // do nothing
    }

    private static getRibbonKey(ribbonTheme: RibbonTheme): string {
        switch (ribbonTheme) {
            case RibbonTheme.BLUE:
                return Keys.CAMPAIGN_RIBBON_BLUE;
            case RibbonTheme.GREEN:
                return Keys.OFFER_RIBBON_FAT;
        }
        return Keys.OFFER_RIBBON_FAT;
    }

    private static getMainColor(ribbonTheme: RibbonTheme): string {
        switch (ribbonTheme) {
            case RibbonTheme.BLUE:
                return '#c9fdff';
            case RibbonTheme.GREEN:
                return '#e6ff00';
        }
        return '#e6ff00';
    }

    private static getTimerColor(ribbonTheme: RibbonTheme): string {
        switch (ribbonTheme) {
            case RibbonTheme.BLUE:
                return '#dcfcf0';
            case RibbonTheme.GREEN:
                return '#ffc969';
        }
        return '#e6ff00';
    }
}

export enum RibbonTheme {
    GREEN = 'GREEN',
    BLUE = 'BLUE',
}
